import React, { Component, PropTypes } from 'react';

export default class EmailField extends Component {
    static propTypes = {
        val: PropTypes.string.isRequired,
        id: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
        help: PropTypes.string.isRequired
    };

    state = {
        val : ''
    };

    componentDidMount() {

    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            val: nextProps.val
        });
    }

    shouldComponentUpdate(nextProps, nextState) {
        return true;
    }

    render() {
        var className = this.state.val ? 'form-control edited' : 'form-control';

        return (
            <div className="form-group form-md-line-input form-md-floating-label">
                <input type="email" className={className} id={this.props.id}
                       name={this.props.id} onChange={(e) => { this.setState({val : e.target.value}) }}
                       value={this.state.val} />

                <label htmlFor={this.props.id}>{this.props.label}</label>
                <span className="help-block">{this.props.help}</span>
            </div>
        )
    }
}


/** WEBPACK FOOTER **
 ** ./src/commons/Inputs/EmailField.js
 **/